module.exports = __webpack_public_path__ + "static/media/profile-picture-1024w.30ac223c.jpg";